<template>
  <v-col
    cols=auto>
    <a href="https://twitter.com/Prosense_nuco" target="_blank">
      <v-icon
        class="sns-icon"
        dark
        large>
        mdi-twitter
      </v-icon>
    </a>
    <a href="https://www.facebook.com/ProsenseEducation" target="_blank">
      <v-icon
        class="sns-icon"
        dark
        large>
        mdi-facebook-box
      </v-icon>
    </a>
    <a href="https://www.youtube.com/channel/UCHxqQ8bUg5F2GW79D_DvSjQ" target="_blank">
      <v-icon
        class="sns-icon"
        dark
        large>
        mdi-youtube
      </v-icon>
    </a>
    <a href="https://lin.ee/oKN5sWr" target="_blank">
      <v-icon
        class="sns-icon"
        dark
        large>
        fab fa-line
      </v-icon>
    </a>
  </v-col>
</template>

<script>
export default {
  
}
</script>

<style scoped>
.sns-icon {
  padding: 0px 5px;
}
</style>